import React, { useState } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();

    const predefinedEmail = "rinesagllareva@gmail.com";
    const predefinedPassword = "admin";

    if (email === predefinedEmail && password === predefinedPassword) {
      sessionStorage.setItem("isAuthenticated", "true"); // Set session storage to indicate authenticated state
      navigate("/dashboard");
    } else {
      alert("Invalid email or password");
    }
  };

  return (
    <div className="unique-background">
      <div className="unique-shape"></div>
      <div className="unique-shape"></div>
      <form onSubmit={handleLogin} className="unique-form">
        <h3 className="unique-title">Login Here</h3>

        <label htmlFor="unique-email" className="unique-label">
          Email
        </label>
        <input
          type="text"
          placeholder="Email"
          id="unique-email"
          className="unique-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label htmlFor="unique-password" className="unique-label">
          Password
        </label>
        <input
          type="password"
          placeholder="Password"
          id="unique-password"
          className="unique-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit" className="unique-button">
          Log In
        </button>

        <div className="unique-social">
          <div className="unique-go">
            <i className="fab fa-google"></i> Google
          </div>
          <div className="unique-fb">
            <i className="fab fa-facebook"></i> Facebook
          </div>
        </div>
      </form>
    </div>
  );
};

export default Login;
